import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IEventHandler } from "../../models/event/eventHandler";
import { Translations } from "ui/Scripts/source/models/translations";
import { Button } from "ui/Scripts/source/components/framework/button";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";

//EventHandlerSummaryListTitleRow
//***************************************************************
export class EventHandlerSummaryListTitleRow extends React.Component<{}, {}> {
    render() {
        return (
            <div className="lineContainer">
                <div className="line title">
                    <div className="row">
                        <div className="col-8">{Translations.EventHandler}</div>
                        <div className="col-4 ra">{Translations.Approval}</div>
                    </div>
                </div>
            </div>
        );
    }
}

//EventHandlerSummaryListLine
//***************************************************************
export interface IEventHandlerSummaryListLineProp {
    userCode: string;
    eventHandler: IEventHandler;
    onApproveClick: () => void;
}

export class EventHandlerSummaryListLine extends React.Component<IEventHandlerSummaryListLineProp, {}> {
    render() {
        const props = this.props;
        const eventHandler = props.eventHandler;
        const currentUser = props.onApproveClick && props.userCode === eventHandler.userCode;
        const approved = !Base.isNullOrUndefined(eventHandler.approveDate);
        return (
            <div className="line">
                <div className="row">
                    <div className={"col" + (approved ? " col-8" : (currentUser ? " col-8" : " col-12"))}>
                        <AvatarImage
                            classes="leftDataCont"
                            name={eventHandler.userName}
                            image={eventHandler.userPicture}
                        />
                        <div className="dataCont rightAvatar">
                            <div className="singleLine">{eventHandler.userName}</div>
                        </div>
                    </div>
                    {approved &&
                        <div className="col col-4 ra"><span className="es s2">{Base.timeToDateStr(eventHandler.approveDate)}</span></div>
                    }
                    {currentUser && !approved &&
                        <div className="col col-4 ra">
                            <Button
                                buttonType={DialogButtonType.Default}
                                title={Translations.Approve}
                                onClick={props.onApproveClick}
                            />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

//EventHandlerSummaryList
//***************************************************************
export interface IEventHandlerSummaryListProp {
    userCode: string;
    eventHandlers: IEventHandler[];
    onApproveClick: () => void;
}

export class EventHandlerSummaryList extends React.Component<IEventHandlerSummaryListProp, { }> {
    render() {
        const props = this.props;
        const eventHandlers = props.eventHandlers;
        return (
            <div>
                <EventHandlerSummaryListTitleRow />
                <div className="lineContainer eventHandlers">
                    {eventHandlers.map((eventHandler) =>
                        <EventHandlerSummaryListLine
                            key={eventHandler.id}
                            userCode={props.userCode}
                            eventHandler={eventHandler}
                            onApproveClick={props.onApproveClick}
                        />
                    )}
                </div>
            </div>
        );
    }
}